import { render, staticRenderFns } from "./UmanjeniSatBase.vue?vue&type=template&id=c57d7c9c&scoped=true&"
import script from "./UmanjeniSatBase.vue?vue&type=script&lang=js&"
export * from "./UmanjeniSatBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c57d7c9c",
  null
  
)

export default component.exports